import React, { FC, useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import Details from "../../static/images/CrewTiles/Detailstils.svg";

import UserIcon from "../../static/svg/UserIcon";
import Flows from "../../static/images/CrewTiles/Flowtils.svg";
import LogsIcon from "../../static/svg/LogsIcon";
import HoldersIcon from "../../static/svg/HoldersIcon";
import KnowledgehubIcon from "../../static/svg/KnowledgehubIcon";
import KnowledgehubchatgptIcon from "../../static/svg/KnowledgehubchatgptIcon";
import KnowledgehubcludeIcon from "../../static/svg/KnowledgehubcludeIcon";
import KnowledgehubmistralIcon from "../../static/svg/KnowledgehubmistralIcon";
import DetailsIcon from "../../static/svg/DetailsIcon";
import ConfigurationsTileIcon from "../../static/svg/ConfigurationsTileIcon";
import TrainerTile from "../../static/svg/TrainerTile";
import FinetureTile from "../../static/svg/FinetureTile";

import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import { service } from "../../../services/AxiosServices";
import RightArrowIcon from "../../static/svg/RightArrowIcon";
import LeftArrowIcon from "../../static/svg/LeftArrowIcon";
import CenterArrowIco from "../../static/svg/CenterArrowIco";
import AnalyzeTileIcon from "../../static/svg/AnalyzeTileIcon";
import PrepareTile from "../../static/svg/PrepareTile";
import { usePhase } from "../../../context/PhaseContext";
import Finetunewhite from "../../static/svg/Finetunewhite";
import Trainerwhiteicon from "../../static/svg/Trainerwhiteicon";
import Prepare from "../../static/svg/Prepare";
import Analyze from "../../static/svg/Analyze";

interface TitleProps {
  title: string;

  spaceName: string;
  spaceId?: string;
}
//  Component that displays a set of interactive tiles for managing space-related features.

const SpaceScreen: FC<TitleProps> = ({ title, spaceId, spaceName }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [spacename, setSpacename] = useState("");
  const spaceConfig = location.pathname.includes("/space-config");
  const space = location.pathname.startsWith("/space");
  const { id } = useParams()
  const { getPhase, fetchPhase,fetchTrainingRecords,getAnalyzedRecordsCount } = usePhase();
  const currentPhase = getPhase(Number(id));
  const analyzedData = getAnalyzedRecordsCount(Number(id))
  useEffect(() => {
    if (id) {
      fetchPhase(Number(id), "knowledge_hub");
      service<{ data: any[] }>(
        "api/fetch-analyse-docs/",
        "post",
        {
          entity_id: id,
          entity_type: "Knowledge hub"
        }
      ).then(response => {
        if (response?.data?.data) {
          fetchTrainingRecords(Number(id), response.data.data);
        }
      }).catch(err => {
        console.error("Error loading analyzed records:", err);
      });
    }
    
    
  }, [id]);


  useEffect(() => {
    const singleSpace = async () => {
      try {
        const response = await service<any>("api/get-spaces", "post", {
          project_id: localStorage.getItem("project_id"),
        });

        const formattedData = response?.data?.response?.find(
          (ele: any) => ele.id === Number(spaceId)
        )?.space_name;

        setSpacename(formattedData);
      } catch (err) {
        console.log(err);
      }
    };
    singleSpace();
  }, [spaceId]);

  const tiles = [
    ...(spaceConfig
      ? [
        {
          name: "Users",
          path: `/user-page/space/${spaceId}`,
          icon: UserIcon,
        },
        {
          name: "Knowledge hub trainers",
          path: `/knowledge_hub_user/${spaceId}`,
          icon: HoldersIcon,
        },
        {
          name: "Details",
          path: `/space_detail/${spaceId}`,
          icon: DetailsIcon,
        },
        { name: "Knowledge finetuners", path: ``, icon: FinetureTile },
        { name: "Logs", path: null, icon: LogsIcon },
      ]
      : [
        {
          name: "Knowledge hub configurations",
          path: `/space-config/${spaceId}`,
          icon: ConfigurationsTileIcon,
        },
        {
          name: "Knowledge hub training center",
          path: `/training-space/${spaceId}/upload`,
          icon: TrainerTile,
        },
        {
          name: "Knowledge hub finetuning center",
          path: `/ai_space/${spaceId}/section`,
          icon: FinetureTile,
        },
      ]),

    // { name: "Knowledge hub", path: `/training-space/${spaceId}/upload`, icon: KnowledgehubIcon },
    // { name: "Knowledge hub explorer (ChatGPT)", path: `/ai_space/${spaceId}/section`, icon: KnowledgehubchatgptIcon },
    // { name: "Knowledge hub explorer (Claude)", path: `/ai_space/${spaceId}/section_claude`, icon: KnowledgehubcludeIcon },
    // { name: "Knowledge hub explorer (Mistral)", path: `/ai_space/${spaceId}/section_mistral`, icon: KnowledgehubmistralIcon },
    // { name: 'User', path: '/manage-users', icon: UserIcon },

    // { name: "Logs", path: null, icon: LogsIcon },
  ];
  const handleTileClick = (path: string | null) => {
    if (path) {
      navigate(path, { state: { spaceName: title } });
    } else {
      return null;
    }
  };

  const content = (
    <div className="All-cards p-3">
      {tiles.map((tile, index) => (
        <div
          key={index}
          onClick={() => handleTileClick(tile.path)}
          style={{ cursor: "pointer" }}
        >
          <div className="assigned_tiles_inner activate">
            {typeof tile.icon === "string" ? (
              <img src={tile.icon} alt={tile.name} />
            ) : (
              <tile.icon />
            )}
            <div className="tile mt-3">{tile.name}</div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <SectionHeader
        back={true}
        title={
          spaceConfig
            ? `Knowledge hub configurations`
            : `Knowledge hub: ${spacename}`
        }
      ></SectionHeader>

      <WindowHeightComponent className={""}>
        <>
          <div className="d-flex flex-column h-100">
            <div className="flex-grow-1">
              <div className="d-flex align-items-center p-3">
                <div className="flex-1">
                  <div className="workflow-container-grid mb-5">
                    {/* Analyze */}
                    <div
                      style={
                        getPhase(Number(spaceId)) === 0  &&  analyzedData?
                        { backgroundColor: "#FD7E14", color: "white" }:
                        getPhase(Number(spaceId)) >= 1
                          ? { backgroundColor: "#17b73b", color: "white" }
                          : {}
                      }
                      onClick={() => navigate(`/space-analyzed-records/${id}`)}
                      className="tiles"
                    >
                      <div className="mb-2">
                        {getPhase(Number(spaceId)) >= 1 ? <Analyze /> : <AnalyzeTileIcon />}
                      </div>
                      <div className="">Analyze</div>
                    </div>

                    <div className="arrow d-flex align-items-center">
                      <span><RightArrowIcon /></span>
                    </div>

                    {/* Prepare */}
                    <div
                      style={
                        getPhase(Number(spaceId)) === 1
                          ? { backgroundColor: "#FD7E14", color: "white" }
                          : getPhase(Number(spaceId)) >= 2
                            ? { backgroundColor: "#17b73b", color: "white" }
                            : {}
                      }
                      onClick={() => navigate(`/space-prepared-records/${id}`)}
                      className="tiles"
                    >
                      <div className="mb-2">
                        {getPhase(Number(spaceId)) >= 1 ? <Prepare /> : <PrepareTile />}
                      </div>
                      <div className="">Prepare</div>
                    </div>

                    <div className="arrow d-flex align-items-center">
                      <span><RightArrowIcon /></span>
                    </div>

                    {/* Training Center */}
                    <div
                      style={
                        getPhase(Number(spaceId)) >= 4
                          ? { backgroundColor: "#17b73b", color: "white" }
                          : getPhase(Number(spaceId)) === 3
                            ? { backgroundColor: "#FD7E14", color: "white" }
                            : {}
                      }
                      onClick={() => navigate(`/training-space/${spaceId}/upload`)}
                      className="tiles"
                    >
                      <div className="mb-2">
                        {getPhase(Number(spaceId)) >= 3 ? <Trainerwhiteicon /> : <TrainerTile />}
                      </div>
                      <div className="">Training center</div>
                    </div>
                  </div>

                  <div className="workflow-container-grid">
                    {/* Invisible spacing tiles */}
                    <div className="tiles invisible">
                      <div className="">Deploy</div>
                    </div>
                    <div className="arrow d-flex align-items-center invisible">
                      <span><LeftArrowIcon /></span>
                    </div>

                    {/* Deploy tile — no getPhase applied yet */}
                    <div onClick={() => navigate(``)} className="tiles">
                      <div className="mb-2">
                        {/* If needed, same conditional logic can go here */}
                        <FinetureTile />
                      </div>
                      <div className="">Deploy</div>
                    </div>

                    <div className="arrow d-flex align-items-center">
                      <span><LeftArrowIcon /></span>
                    </div>

                    {/* Finetuning Center */}
                    <div
                      style={
                        getPhase(Number(spaceId)) >= 5
                          ? { backgroundColor: "#17b73b", color: "white" }
                          : getPhase(Number(spaceId)) === 4
                            ? { backgroundColor: "#FD7E14", color: "white" }
                            : {}
                      }
                      onClick={() =>
                        navigate(`/ai_space/${id}/section`, { state: { spaceName: title } })
                      }
                      className="tiles"
                    >
                      <div className="mb-2">
                        {getPhase(Number(spaceId)) >= 4 ? <Finetunewhite /> : <FinetureTile />}
                      </div>
                      <div className="">Finetuning center</div>
                    </div>
                  </div>

                </div>
                <div>
                  <div>
                    <span>
                      <CenterArrowIco />
                    </span>
                  </div>
                </div>
              </div>
              <div className="px-3 my-1">
                <hr />
              </div>
            </div>
                        
            <div className="workflow-container-grid mt-auto  p-3">
              <div onClick={() => navigate(`/space-config/${spaceId}`)} className="tiles">
                <div className="mb-2">
                  <ConfigurationsTileIcon />
                </div>
                <div className="">Configurations</div>
              </div>
            </div>
          </div>
        </>
        {/* {content} */}
      </WindowHeightComponent>
    </>
  );
};

export default SpaceScreen;
